/* 异步加载 一些弹窗组件 */
// const TerrainElevationTree = () => import('./shpInfoListTree/TerrainElevationTree');

//按需加载
import {} from "../../../api/api";

// import {
// 	EventBus
// } from '../../../static/js/event-bus.js';
import {
  notSimplifyGeoJSON,
  lowSimplifyGeoJSON,
  mediumSimplifyGeoJSON,
  highSimplifyGeoJSON,
} from "@/components/tables/shpInfoList/map.js";
export default {
  components: {
    // TerrainElevation
  },
  props: {},
  data() {
    return {
      shpInfoList_show: true,

      treeData: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      checkedIds: [], //页面加载时默认勾选的id
      isFold: false,
    };
  },
  mounted() {
    this.initTreeData();
  },

  methods: {
    // 初始化列表
    initTreeData() {
      let that = this;
      //对treeData进一步处理，获取到checkedIds。
      this.recursionProjectShpInfo2(this.$GLOBAL.shpInfoListTree);
      this.treeData = this.$GLOBAL.shpInfoListTree;
    },
    recursionProjectShpInfo2(data) {
      data.forEach((item) => {
        if (item.children.length > 0) {
          this.recursionProjectShpInfo2(item.children);
        } else {
          //没有子项时做的操作
          if (!item.shpInfo.type) {
            if (item.shpInfo.isDisplay) {
              if (item.shpInfo.shpUrl) {
                //展示数据
                this.checkedIds.push(item.id);
              }
            }
          } else {
            //为目录
          }
        }
      });
      this.$GLOBAL.shpInfoListTree = data;
    },
    handleCheck(data, status) {
      //修改节点的选中状态时触发。
    },
    nodeClick(data) {
      if (data.geoJsonLayerId) {
        let geoJsonLayer = this.$GLOBAL.map.getLayerById(data.geoJsonLayerId);
        if (geoJsonLayer) {
          geoJsonLayer.flyTo({
            duration: 2,
            maxHeight: 30000,
          });
        } else {
          this.$alert(
            "该节点尚未被勾选，或者还没有在后台上传该节点对应的shp文件。",
            "友情提示",
            {
              confirmButtonText: "确定",
              type: "warning",
              callback: (action) => {},
            }
          );
        }
      } else {
        this.$alert(
          "该节点尚未被勾选，或者还没有在后台上传该节点对应的shp文件。",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {},
          }
        );
      }
    },
    handleCheckChange(data, status) {
      if (!data.shpInfo.type) {
        if (!status) {
          this.$GLOBAL.map.removeLayer(data.geoJsonLayerId, true);
          this.recursionUpdate(
            this.$GLOBAL.shpInfoListTree,
            data.geoJsonLayerId,
            false
          );
        } else {
          if (data.shpInfo.shpUrl && data.id !== 234716734414917) {
            const isRiver =
              data.title === "贵州省水网" && data.id === 235337208590405;
            let url = this.$GLOBAL.localResourcesPath + data.shpInfo.shpUrl;
            let simplifyFunc = notSimplifyGeoJSON;
            if (
              data.shpInfo?.isOptimization != undefined &&
              !data.shpInfo?.isOptimization
            ) {
              simplifyFunc = notSimplifyGeoJSON;
            } else {
              switch (data.shpInfo?.optimizationDegree) {
                case "low":
                  simplifyFunc = lowSimplifyGeoJSON;
                  break;
                case "medium":
                  simplifyFunc = mediumSimplifyGeoJSON;
                  break;
                case "high":
                  simplifyFunc = highSimplifyGeoJSON;
                  break;
                default:
                  simplifyFunc = notSimplifyGeoJSON;
                  break;
              }
            }
            let geoJsonLayer = new mars3d.layer.GeoJsonLayer({
              name: data.title,
              //url: "/baseIP/" + data.shpInfo.shpUrl,
              url: url,
              format: simplifyFunc,
              // symbol: {
              //   type: isRiver ? "polygon" : "polylineC",
              //   styleOptions: {
              //     color: data.shpInfo.shpColor,
              //     outline: true,
              //     outlineStyle: {
              //       color: data.shpInfo.shpColor, //"#ffffff",
              //       width: 3,
              //       opacity: 1,
              //     },
              //     label: {
              //       //面中心点，显示文字的配置
              //       text: "{NAME}", //对应的属性名称
              //       //text: data.shpInfo.shpName, //不应该这样写，因此让程序自己去解析文件里的name。
              //       opacity: 1,
              //       font_size: data.shpInfo.shpTextSize || 26,
              //       color: "#ffffff",
              //       visibleDepth: false,
              //       font_family: "黑体",
              //       outline: true,
              //       outlineColor: "#000000",
              //       outlineWidth: 3,
              //       font_weight: "normal",
              //       font_style: "normal",

              //       distanceDisplayCondition: true,
              //       distanceDisplayCondition_far: data.shpInfo.shpDistinct, //50000,
              //       distanceDisplayCondition_near: 0,
              //       clampToGround: data.shpInfo.clampToGround, //true, //贴地
              //       classificationType: Cesium.ClassificationType.TERRAIN, // 避免贴地时贴到模型上。
              //     },
              //     distanceDisplayCondition: true,
              //     distanceDisplayCondition_far: data.shpInfo.shpDistinct, //50000,
              //     distanceDisplayCondition_near: 0,
              //     clampToGround: data.shpInfo.clampToGround, //true, //贴地
              //     classificationType: Cesium.ClassificationType.TERRAIN, // 避免贴地时贴到模型上。
              //   },
              // },
              symbol: {
                type: "polylineC",
                styleOptions: {
                  clampToGround: data.shpInfo.clampToGround,
                  width: data.shpInfo.width,
                  distanceDisplayCondition: true,
                  distanceDisplayCondition_far:
                    data.shpInfo.shpDistinct || 1000000,
                  distanceDisplayCondition_near: 0,
                  width: data.shpInfo.width,
                  materialType: data.shpInfo.materialType,
                  materialOptions: {
                    color: data.shpInfo.shpColor,
                    opacity: 0.9,
                    dashLength: data.shpInfo.dashLength,
                    image: "/img/textures/LinkPulse.png",
                    glowPower: 0.06,
                    speed: 3,
                  },
                },
                label: {
                  //面中心点，显示文字的配置
                  text: "{NAME}", //对应的属性名称
                  //text: data.shpInfo.shpName, //不应该这样写，因此让程序自己去解析文件里的name。
                  opacity: 1,
                  font_size: data.shpInfo.shpTextSize || 26,
                  color: "#ffffff",
                  visibleDepth: false,
                  font_family: "黑体",
                  outline: true,
                  outlineColor: "#000000",
                  outlineWidth: 3,
                  font_weight: "normal",
                  font_style: "normal",

                  distanceDisplayCondition: true,
                  distanceDisplayCondition_far: data.shpInfo.shpDistinct, //50000,
                  distanceDisplayCondition_near: 0,
                  clampToGround: data.shpInfo.clampToGround, //true, //贴地
                  classificationType: Cesium.ClassificationType.TERRAIN, // 避免贴地时贴到模型上。
                },
              },
              hasZIndex: true, //是否可以调整图层顺序（在同类型图层间）
              zIndex: data.shpInfo.order, //图层顺序，数字大的在上面。（当hasZIndex为true时）
            });
            // let geoJsonLayer = new mars3d.layer.GeoJsonLayer({
            //   name: data.title,
            //   url: "/baseIP/" + data.shpInfo.shpUrl,
            //   format: simplifyGeoJSON, // 用于自定义处理geojson
            //   symbol: {
            //     type: "polylineC",
            //     styleOptions: {
            //       width: 2,
            //       color: data.shpInfo.shpColor,
            //       distanceDisplayCondition: true,
            //       distanceDisplayCondition_far: 5000000,
            //       //data.shpInfo.shpDistinct || 500000,
            //       distanceDisplayCondition_near: 0,
            //       clampToGround: true, //贴地
            //       classificationType: Cesium.ClassificationType.TERRAIN, // 避免贴地时贴到模型上。
            //       label: {
            //         text: "{NAME}",

            //         opacity: 1,
            //         font_size: data.shpInfo.shpTextSize || 26,
            //         color: "#ffffff",

            //         font_family: "黑体",
            //         outline: true,
            //         outlineColor: "#000000",
            //         outlineWidth: 3,
            //         font_weight: "normal",
            //         font_style: "normal",
            //       },
            //     },
            //   },
            //   //show: true,
            //   //flyTo: true,
            //   hasZIndex: true, //是否可以调整图层顺序（在同类型图层间）
            //   zIndex: data.shpInfo.order, //图层顺序，数字大的在上面。（当hasZIndex为true时）
            // });
            this.$GLOBAL.map.addLayer(geoJsonLayer);
            data.geoJsonLayerId = geoJsonLayer.id;
            this.recursionUpdate(
              this.$GLOBAL.shpInfoListTree,
              data.geoJsonLayerId,
              true
            );
          }
        }
      } else {
        //为目录
      }
    },
    shpInfoList_click() {
      this.$emit("shpInfoListBox_close");
    },
    //修改数结构数据里对应项的显示属性,方便用户关闭弹窗再打开后，目录树的勾选状态与上次操作结果一致。
    recursionUpdate(data, id, show) {
      data.forEach((item) => {
        if (item.children.length > 0) {
          this.recursionUpdate(item.children, id, show);
        } else {
          if (item.geoJsonLayerId && item.geoJsonLayerId === id) {
            item.shpInfo.isDisplay = show;
          }
        }
      });
      this.$GLOBAL.shpInfoListTree = data;
    },
  },
  watch: {},
};
